import Link from "next/link";
import { useSelector } from "react-redux";

import type { OftenSearchedGroup } from "~/utils/catalog/oftenSearched";

import styles from "./index.module.scss";

/**
 * «Часто ищут» — ссылки на страницы фильтров раздела (ТЗ п. 5.3). Состав
 * собирается на сервере (sectionLogic), здесь только вывод: все ссылки сразу,
 * без «показать ещё» и без target="_blank", чтобы их видел робот.
 */
export default function OftenSearched() {
  const { oftenSearched } = useSelector((state: any) => state.section);

  if (!oftenSearched?.length) {
    return null;
  }

  return (
    <div className={styles.OftenSearched}>
      <div className={styles.Title}>Часто ищут</div>
      {oftenSearched.map((group: OftenSearchedGroup) => (
        <div className={styles.Group} key={group.title}>
          <div className={styles.GroupTitle}>{group.title}</div>
          <ul className={styles.Items}>
            {group.links.map((link) => (
              <li key={link.url}>
                <Link href={link.url}>
                  <a className={styles.Item} href={link.url}>
                    {link.anchor}
                  </a>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
